"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _alloyReactButton = _interopRequireDefault(require("@adsk/alloy-react-button"));
var _alloyReactDivider = _interopRequireDefault(require("@adsk/alloy-react-divider"));
var _i18n = require("../../../i18n");
var _QuickReportsPanelContext = _interopRequireDefault(require("../QuickReportsPanelContext"));
var _SuccessPanelHeader = _interopRequireDefault(require("./SuccessPanelHeader"));
var _SuccessPanelBody = _interopRequireDefault(require("./SuccessPanelBody"));
var _hooks = require("../hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SuccessPanel = _ref => {
  let {
    reportUrl
  } = _ref;
  const {
    T
  } = (0, _i18n.useTranslation)();
  const {
    reportService,
    reportType,
    reportFormat
  } = (0, _react.useContext)(_QuickReportsPanelContext.default);
  const {
    trackDownload
  } = (0, _hooks.useTrackEvent)({
    reportService,
    reportType,
    reportFormat
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_SuccessPanelHeader.default, null), /*#__PURE__*/_react.default.createElement(_SuccessPanelBody.default, {
    reportUrl: reportUrl
  })), /*#__PURE__*/_react.default.createElement(StyledDivider, null), /*#__PURE__*/_react.default.createElement(DownloadButton, {
    variant: _alloyReactButton.default.VARIANTS.PRIMARY,
    onClick: trackDownload(reportUrl)
  }, T.translate('button.downloadReport')));
};
const Container = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`;
const StyledDivider = (0, _styledComponents.default)(_alloyReactDivider.default)`
  margin-bottom: 12px;
`;
const DownloadButton = (0, _styledComponents.default)(_alloyReactButton.default)`
  width: 100%;
`;
SuccessPanel.propTypes = {
  reportUrl: _propTypes.default.string
};
var _default = exports.default = SuccessPanel;